(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySchedulingV2Controller', CompanySchedulingV2Controller);

    CompanySchedulingV2Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$timeout', 'DialogService', 'CompanyInfoQuery'];

    function CompanySchedulingV2Controller($rootScope, $scope, $state, $stateParams, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, $timeout, DialogService, CompanyInfoQuery) {
        var vm = this;
        $rootScope.$broadcast('hideNavBar');
        CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
            if (comp)
                vm.companyId = comp.id;
        })


        //vm.serviceItemId=$stateParams.id;
        //vm.serviceItem=entity;
        //company-servants

        vm.selectedScheduleInfo = 1;
        vm.loadPage = loadPage;
        vm.selectedId = '';
        vm.formState = 'list';
        vm.newItem = newItem;
        vm.editItem = editItem;
        vm.backToList = backToList;
        vm.generateTimeInfo = generateTimeInfo;
        vm.showTimingInfo = showTimingInfo;
        vm.backToScheduleInfo = backToScheduleInfo;
        vm.saveSchedule = saveSchedule;
        vm.save = save;
        vm.schSelected = false;
        vm.schSaved = false;
        vm.step = 0;
        vm.isSaving = false;
        vm.schedulerApi = {refresh: 'not set'};
        vm.hasBaseOffDaySchedule = false;
        vm.defaultBaseOffDayScheduleId = null;
        vm.baseOffDayScheduleSwitch_changed = baseOffDayScheduleSwitch_changed;
        vm.showLimitDates = false;
        vm.showLimitDateChange = showLimitDateChange;

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        vm.refreshList = function () {

            vm.scheduleInfos = [];

            CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
                if (comp) {
                    ScheduleInfoCustom.primaryScheduleInfosByCompany(comp.id).query(function (schedules) {
                        vm.scheduleInfos = schedules;
                        if (vm.scheduleInfos.length == 0)
                            vm.newItem();
                        else {
                            if (!vm.selectedId) {
                                // vm.editItem(vm.scheduleInfos[0]);
                                editItemV2(vm.scheduleInfos[0]);
                            }

                        }
                        // checkShowLimitDates();
                    });


                    ScheduleInfoCustom.getDefaultBaseOffDaySchedule().query().$promise.then(function (sch) {
                        if (sch && sch.id)
                            vm.defaultBaseOffDayScheduleId = sch.id;

                    });


                }
            })
        }

        //
        vm.generateTimesUntil = generateTimesUntil;
        $timeout(function () {
            loadAll();
            loadPage();

        });


        function showTimingInfo() {
            vm.timingInfo = vm.selectedScheduleInfo.timingInfo;
            vm.step = 1;
        }

        vm.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }


        function saveSchedule() {
            vm.selectedScheduleInfo.companyId = vm.companyId;
            vm.isSaving = true;

            if (vm.hasBaseOffDaySchedule && vm.defaultBaseOffDayScheduleId) {
                vm.selectedScheduleInfo.baseOffDayScheduleInfoId = vm.defaultBaseOffDayScheduleId;
            } else {
                vm.selectedScheduleInfo.baseOffDayScheduleInfoId = null;
            }

            TimingInfo.saveScheduleInfoForCompany().save(vm.selectedScheduleInfo, function (sch) {

                vm.selectedScheduleInfo = sch;
                vm.selectedId = sch.id;
                //  vm.timingInfo = sch.timingInfo;
                vm.step = 1;
                vm.schSelected = true;
                vm.schSaved = true;
                vm.isSaving = false;
                //vm.refreshList();
            });
        }

        function save() {
            saveSchedule();
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate(vm.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save(vm.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                vm.timingInfo = timingInfo;
                vm.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if (vm.schedulerApi.refreshScheduler)
                vm.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            vm.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            vm.scheduleInfos = [];
            vm.refreshList();
        }

        function newItem() {
            //
            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            vm.selectedScheduleInfo.companyId = vm.companyId;
            vm.schSelected = true;
            vm.schSaved = false;
            updateTabs();

        }

        function editItem(id) {

            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                vm.selectedScheduleInfo = sch;
                checkShowLimitDates();

                var now = new Date();
                now.setDate(now.getDate() - 1);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                var tempArr = [];
                angular.forEach(vm.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                    if (new Date(exDate.startDate) > now) {
                        tempArr.push(exDate);
                        // var index = vm.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                        //
                        // vm.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                    }
                })
                vm.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
                vm.schSelected = true;
                vm.schSaved = true;


                if (vm.selectedScheduleInfo && vm.selectedScheduleInfo.baseOffDayScheduleInfo) {
                    vm.hasBaseOffDaySchedule = true;
                }

                updateTabs();
            });

        }

        function editItemV2(sch) {

            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedId = sch.id;

            vm.selectedScheduleInfo = sch;
            checkShowLimitDates();

            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            angular.forEach(vm.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                    // var index = vm.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                    //
                    // vm.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                }
            })
            vm.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
            vm.schSelected = true;
            vm.schSaved = true;


            if (vm.selectedScheduleInfo && vm.selectedScheduleInfo.baseOffDayScheduleInfo) {
                vm.hasBaseOffDaySchedule = true;
            }

            updateTabs();


        }

        function updateTabs() {
            if (vm.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            vm.formState = 'list';
            vm.selectedScheduleId = '';
            vm.refreshList();
        }

        function baseOffDayScheduleSwitch_changed() {


        }

        function showLimitDateChange() {
            if (!vm.showLimitDates) {
                vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate = null;
                vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {

            if (vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate) {
                vm.showLimitDates = true;
                return;
            }

            if (vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate) {

                var date = new Date();
                var fromDate = new Date(vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate);
                if (fromDate > date)
                    vm.showLimitDates = true;
            }

        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else
                $state.go('supplierPanel-v2.setting');
        }


    }
})();
